import React from 'react';
import styled from 'styled-components';
import CountryLabel from '../CountryLabel';
import Pellet from '../Pellet';
import { I18n } from 'react-redux-i18n';
import Tooltip from '../Tooltip';
import Icon from '../Icon';

const isMobile = window.innerWidth <= 845;

const Container = styled.div`
  height: initial;
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  z-index: 1;
  position: relative;

  .pictureContainer {
    position: relative;
  }

  .rankContainer {
    position: absolute;
    bottom: 0px;
    left: 20px;
    width: 20px;
    height: 20px;
    border-radius: 4px 4px 0px 0px;
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    z-index: 2;
    color: white;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-size: 12px;
    }
  }
`;

const Picture = styled.div`
  height: 100px;
  overflow: hidden;
  background: url(${(props) => props.picture}) no-repeat center;
  background-size: auto auto;
  -webkit-background-size: cover;
  background-size: cover;
  width: 100%;
  max-height: 200px;
  border: 1px solid rgba(173, 181, 189, 0.2);
  border-bottom: 0;
`;

const Distribution = styled.div`
  border-right: 1px solid rgba(173, 181, 189, 0.2);
  border-left: 1px solid rgba(173, 181, 189, 0.2);

  @media (max-width: 845px) {
    border-right: none;
    border-left: none;
  }

  .statusContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 6px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    margin-bottom: 2px;
  }

  .statusContainer p {
    margin-left: 7px;
  }

  background-color: ${(props) => props.theme.colors['white']};
  h3 {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 16px;
    color: #4b4b4b;
    margin-right: 2px;
  }

  .informations {
    padding: 10px 0 17px 7px;

    @media (max-width: 845px) {
      padding: 0 8px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  div {
    margin: 0 0 0 1px;
  }

  .country-label-city {
    margin-left: 10px;
  }

  .contact {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;

    @media (max-width: 845px) {
      margin-bottom: 0;
    }

    a {
      text-decoration: none;
      color: inherit;
    }

    > * {
      margin-left: 5px;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      background-color: rgba(173, 181, 189, 0.75);
      color: white;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      min-width: 24px;
      min-height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      justify-self: center;
      align-self: center;
      line-height: 10px;
    }
  }
`;

const Shadow = styled.div`
  width: 100%;
  height: 31.5px;
  opacity: 0.3;
  border-radius: 6.8px;
  -webkit-filter: blur(13.6px);
  -webkit-filter: blur(13.6px);
  filter: blur(13.6px);
  background-color: #18222c;
  margin: auto;
  position: absolute;
  bottom: -10px;
  z-index: 0;
`;

const Wines = styled.div`
  height: 37px;
  min-height: 37px;
  background-color: #2b3d54;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  p {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    color: ${(props) => props.theme.colors['white']};
  }
`;

const Box = styled.div`
  position: relative;
  margin-bottom: 25px;
  width: 100%;
  margin: auto;
`;

const MobileContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 3.6fr;
  grid-gap: 8px;
  background-color: transparent;
  height: 100%;

  .distributionContainer {
    padding: 6px 0;
    display: grid;
    gap: 8px;
  }

  p {
    font-family: 'Oswald';
  }
`;

const renderStatus = (status) => {
  return (
    <div className="statusContainer">
      <Pellet value={status} />
      <p>
        {status === 'positive'
          ? I18n.t('posComponent.pos')
          : status === 'negative'
            ? I18n.t('posComponent.lost')
            : I18n.t('posComponent.conquer')}
      </p>{' '}
    </div>
  );
};

const PointOfSales = (props) => {
  if (isMobile) {
    return (
      <Box>
        <MobileContainer>
          <div
            style={{
              background: '#F9DFD6',
              color: '#E25D34',
              display: 'grid',
              gridTemplateRows: '1fr 1fr',
              borderRadius: '4px 4px 0 0'
            }}
          >
            {props.rank && (
              <p
                style={{
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {props.rank}
              </p>
            )}
            <Wines
              style={{ background: '#E25D34', borderRadius: '0 0 4px 4px' }}
            >
              <p>
                {props.dn_total} {I18n.t('generic')}
              </p>
            </Wines>
          </div>
          <Distribution className="distributionContainer">
            <div className="informations">
              {props.status && renderStatus(props.status)}
              <h3 style={{ fontSize: 12, color: '#2B3D54', fontWeight: 600 }}>
                {props.name.toUpperCase()}
              </h3>
              {props.country && (
                <CountryLabel
                  className="CountryLabel"
                  name={props.country_code}
                  city={props.city}
                />
              )}
            </div>
            {props.contact && (
              <div className="contact">
                {props.contact.phone && (
                  <Tooltip
                    placement="top"
                    noCursor
                    content={props.contact.phone}
                  >
                    <a>
                      <Icon className="phone" icon="phone" />
                    </a>
                  </Tooltip>
                )}
                {props.contact.email && (
                  <Tooltip placement="top" content={props.contact.email}>
                    <a
                      href={
                        props.contact.email.startsWith('http')
                          ? props.contact.email
                          : `mailto:${props.contact.email}`
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      @
                    </a>
                  </Tooltip>
                )}
                {props.contact.address && (
                  <Tooltip placement="top" content={props.contact.address}>
                    <a
                      href={`https://maps.google.com/?ll=${props.contact.latitude},${props.contact.longitude}`}
                    >
                      <Icon icon="localisationContainer" />
                    </a>
                  </Tooltip>
                )}
                {props.contact.site && (
                  <Tooltip placement="top" content={props.contact.site}>
                    <a
                      href={props.contact.site}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Icon icon="world" />
                    </a>
                  </Tooltip>
                )}
              </div>
            )}
          </Distribution>
        </MobileContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Container>
        <div className="pictureContainer">
          <Picture picture={props.photo} />
          {props.rank && (
            <div className="rankContainer">
              <p>#{props.rank}</p>
            </div>
          )}
        </div>
        <Distribution>
          <div className="informations">
            {props.status && renderStatus(props.status)}
            <h3>{props.name}</h3>
            {props.country && (
              <CountryLabel
                className="CountryLabel"
                name={props.country_code}
                city={props.city}
              />
            )}
          </div>
          {props.contact && (
            <div className="contact">
              {props.contact.phone && (
                <Tooltip placement="top" noCursor content={props.contact.phone}>
                  <a>
                    <Icon className="phone" icon="phone" />
                  </a>
                </Tooltip>
              )}
              {props.contact.email && (
                <Tooltip placement="top" content={props.contact.email}>
                  <a
                    href={
                      props.contact.email.startsWith('http')
                        ? props.contact.email
                        : `mailto:${props.contact.email}`
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    @
                  </a>
                </Tooltip>
              )}
              {props.contact.address && (
                <Tooltip placement="top" content={props.contact.address}>
                  <a
                    href={`https://maps.google.com/?ll=${props.contact.latitude},${props.contact.longitude}`}
                  >
                    <Icon icon="localisationContainer" />
                  </a>
                </Tooltip>
              )}
              {props.contact.site && (
                <Tooltip placement="top" content={props.contact.site}>
                  <a href={props.contact.site} target="_blank" rel="noreferrer">
                    <Icon icon="world" />
                  </a>
                </Tooltip>
              )}
            </div>
          )}
        </Distribution>
        <Wines>
          <p>
            {props.dn_total} {I18n.t('generic')}
          </p>
        </Wines>
      </Container>
      <Shadow />
    </Box>
  );
};

export default PointOfSales;
